export default __webpack_public_path__ + "static/robertj-2cae25cadcc36e8ea61723d99912b430.webp";